import React, { useEffect } from 'react';

import Text from 'common/components/Text/Text';

import styles from './Login.module.scss';

const BannerCarousel = (): React.ReactElement => {
  useEffect(() => {
    const button = document.getElementById('slide1');
    button?.click();
  }, []);

  return (
    <div className={styles.bannerContainer}>
      <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="0"
            className={`active ${styles.buttonDot}`}
            aria-current="true"
            aria-label="Slide 1"
            id="slide1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="1"
            aria-label="Slide 2"
            className={`${styles.buttonDot}`}
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="2"
            aria-label="Slide 3"
            className={`${styles.buttonDot}`}
          ></button>
        </div>
        <div className={`carousel-inner ${styles.carouselContainer}`}>
          <div className="carousel-item active" data-bs-interval="10000">
            <div className={`carousel-caption ${styles.banner} ${styles.firstBanner}`}>
              <div className={styles.textContainer}>
                <Text size={24} weight={500} color="primary">
                  Start your
                </Text>
                <Text size={24} weight={500} color="primary">
                  <Text size={24} weight={700} color="primary" inline>
                    personalized
                  </Text>{' '}
                  journey
                </Text>
              </div>
            </div>
          </div>
          <div className="carousel-item" data-bs-interval="10000">
            <div className={`carousel-caption ${styles.banner} ${styles.secondBanner}`}>
              <div className={`mt-5 ${styles.textContainer}`}>
                <Text size={24} weight={500} color="primary">
                  <Text size={24} weight={700} color="primary" inline>
                    Assigned expert
                  </Text>{' '}
                  serves
                </Text>
                <Text size={24} weight={500} color="primary">
                  the whole flow
                </Text>
              </div>
            </div>
          </div>
          <div className="carousel-item" data-bs-interval="10000">
            <div className={`carousel-caption ${styles.banner} ${styles.thirdBanner}`}>
              <div className={`mt-4 ${styles.textContainer}`}>
                <Text size={24} weight={700} color="primary" inline>
                  Artificial intelligence
                </Text>
                <Text size={24} weight={500} color="primary">
                  support you efficiently
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerCarousel;
